module.exports = __webpack_public_path__ + "media/components/Sponsors/FormTags/Categories/21-4b5851d45b4161a59fa0d8a56cf769fa.png";